import { components } from "@/api-schema";
import { RelocationOrderTransportCompanyRejectStatus, RelocationOrderStatus } from "@/api-schema-enums";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export interface LoadStatusChange {
  relocationOrder: RelocationOrder;
  status: RelocationOrderStatus;
}

interface TransportCompanyRejectVehicleMutationInput {
  relocationOrder: RelocationOrder;
  body: { status: RelocationOrderTransportCompanyRejectStatus };
}

export type TransportCompanyPickUpVehicleMutation = (relocationOrder: RelocationOrder) => Promise<void>;
export type TransportCompanyRejectVehicleMutation = (
  input: TransportCompanyRejectVehicleMutationInput,
) => Promise<void>;

export function toTransportCompanyRejectStatus(
  status: RelocationOrderStatus,
): RelocationOrderTransportCompanyRejectStatus | null {
  switch (status) {
    case RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle:
      return RelocationOrderTransportCompanyRejectStatus.TransportCompanyRejectedDamagedVehicle;
    case RelocationOrderStatus.TransportCompanyRejectedMissingVehicle:
      return RelocationOrderTransportCompanyRejectStatus.TransportCompanyRejectedMissingVehicle;
    case RelocationOrderStatus.TransportCompanyRejectedMissingKeys:
      return RelocationOrderTransportCompanyRejectStatus.TransportCompanyRejectedMissingKeys;
    default:
      return null;
  }
}

export async function confirmLoadStatusChanges(
  changedItems: LoadStatusChange[],
  transportCompanyPickUpVehicleMutation: TransportCompanyPickUpVehicleMutation,
  transportCompanyRejectVehicleMutation: TransportCompanyRejectVehicleMutation,
): Promise<void> {
  const pendingRejectMutations: Promise<void>[] = [];

  for (const { status, relocationOrder } of changedItems) {
    const rejectStatus = toTransportCompanyRejectStatus(status);
    if (rejectStatus) {
      pendingRejectMutations.push(
        transportCompanyRejectVehicleMutation({ relocationOrder, body: { status: rejectStatus } }),
      );
      continue;
    }

    await Promise.all(pendingRejectMutations);
    pendingRejectMutations.length = 0;
    await transportCompanyPickUpVehicleMutation(relocationOrder);
  }

  await Promise.all(pendingRejectMutations);
}
